import React from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import ReactHtmlParser from "react-html-parser";
import { HeaderSection } from "../../components/shared/HeaderSection";
import { SubTitle } from "../../components/shared/SubTitle";
import { ItemTouristic } from "../../components/tourism/ItemTouristic";

import ROUTES from "../../routes/routes";
import { getTouristRouteById } from "../../services/tourismService";

const RouteDetail = () => {
  const { id } = useParams();

  const { data, isError, isLoading, isFetching } = useQuery(
    ["tourist-route", id],
    () => getTouristRouteById(id)
  );

  if (isLoading) return <p>Cargando</p>;
  if (isFetching) return <p>Loading feaching...</p>;
  if (isError) return <p>error</p>;

  const cards = data.attraction_servers.map((item) => (
    <ItemTouristic
      key={item.id}
      item={item.tourist_attraction}
      route={ROUTES.ATRACTIVE_DETAIL}
      ncol="4"
    />
  ));

  return (
    <Container>
      <Row>
        <Col md="12">
          <HeaderSection
            route={ROUTES.TROUTES}
            resume="Volver a Rutas Túristicas"
            style={{ borderColor: "#1199B3" }}
          />
          <h1 className="text-center mt-3 mb-3">{data.title}</h1>
        </Col>
      </Row>
      <Row>
        <Col md="7">
          <img
            className="img-fluid d-none d-md-block"
            src={data.image}
            alt="illustration"
          />
        </Col>
        <Col md="5">{ReactHtmlParser(data.description)}</Col>
      </Row>
      <Row>
        <Col md="12 m-1">
          <SubTitle title="Atracciones" position="text-left" />
          <Row>{cards}</Row>
        </Col>
      </Row>
      <HeaderSection
        route={ROUTES.TROUTES}
        resume="Volver a Rutas Túristicas"
        style={{ borderColor: "#1199B3" }}
      />
    </Container>
  );
};

export default RouteDetail;
